var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-cart")]),_vm._v(" Keuangan ")],1),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }